import React, { useState, useEffect } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import matrimonyInstance from "../utils/axios";
import { PAYMENT_TOKEN } from "../API_LIST";
//import { setPaymentDetails } from "../paymentSlice";
import { setPaymentDetails } from "../redux/features/paymentSlice";

const PaymentLinkPage = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    //const { tokenId } = useParams();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [searchParams] = useSearchParams();

    useEffect(() => {
        localStorage.clear();
    }, []);
    

    const proccedPayment = async () => {
      const urlParams = new URLSearchParams(window.location.search);
      const token = urlParams.get("token");
      const type = urlParams.get("type");
      setLoading(true);
        try {
            const paymentLinkEndpoint = PAYMENT_TOKEN.replace("{tokenId}", token) + `&type=${type}`;  
            const response = await matrimonyInstance.post(paymentLinkEndpoint);
            console.log(response);
            var paymentDetails = response.data.paymentDetails;

            paymentDetails = {
              ...paymentDetails, 
              type: type          
          };


            dispatch(setPaymentDetails(paymentDetails));

            if (type === "BAT") {
              navigate("/bat/payment-page");
            } else {
              navigate("/payment-page")
            }
        } catch (error) {
            console.error(error);
            setError(error);
        } finally {
            setLoading(false);
        }
    };

    return (
      <React.Fragment>
        <div
          style={{ minHeight: "90vh" }}
          className="d-flex justify-content-center align-items-start mt-100">
          <div className="d-flex mt-20 mb-20 position-relative">
            <div className="d-flex justify-content-center">
              <button
                className="button payment-btn"
                onClick={proccedPayment}
                disabled={loading}>
                {loading ? "Processing..." : "Proceed to Payment"}
              </button>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
};

export default PaymentLinkPage;
